export const Uris = {
  background: 'https://bing.lunaticplatypus.com/',
  bing: 'https://www.bing.com/',
  axiosHeaders: {
    'Content-Type': 'application/json'
  }
}
